/**
 * Logger Utility
 * Only logs in development mode
 */

export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
}

interface Logger {
  debug: (...args: unknown[]) => void
  info: (...args: unknown[]) => void
  warn: (...args: unknown[]) => void
  error: (...args: unknown[]) => void
  group: (label: string) => void
  groupEnd: () => void
}

const isDev = import.meta.env.DEV

const createLogger = (prefix: string): Logger => {
  const formatMessage = (level: LogLevel, ...args: unknown[]): unknown[] => {
    const timestamp = new Date().toISOString()
    return [`[${timestamp}] [${level.toUpperCase()}] [${prefix}]`, ...args]
  }

  return {
    debug: (...args: unknown[]) => {
      if (isDev) console.log(...formatMessage(LogLevel.DEBUG, ...args))
    },
    info: (...args: unknown[]) => {
      if (isDev) console.info(...formatMessage(LogLevel.INFO, ...args))
    },
    warn: (...args: unknown[]) => {
      if (isDev) console.warn(...formatMessage(LogLevel.WARN, ...args))
    },
    error: (...args: unknown[]) => {
      console.error(...formatMessage(LogLevel.ERROR, ...args))
    },
    group: (label: string) => {
      if (isDev) console.group(`[${prefix}] ${label}`)
    },
    groupEnd: () => {
      if (isDev) console.groupEnd()
    },
  }
}

export const logger = createLogger('App')
export const createLoggerWithPrefix = (prefix: string): Logger => createLogger(prefix)
export type { Logger }
